<style lang="less" scoped>
	.musts {
		color: red;
	}

	/deep/ .el-dialog__title {
		color: #fff !important;
	}

	/deep/ .el-dialog__header {
		padding: 14px 19px 10px;
		background: #05A34A;
		color: #fff;
		font-size: 1.2rem;

		.el-dialog__headerbtn .el-dialog__close {
			color: #fff;
			font-size: 1.4rem;

		}

		.dialog-header-title {
			span {
				margin-left: 0.6rem;
			}
		}
	}

	/deep/ .el-empty {
		background-color: #fff;
		margin: 1rem 0;
	}

	she .meddon {
		background-color: #D7D7D7;
		color: #F90000;
	}

	.sbsource {
		/deep/ .el-switch__label * {
			margin-left: 1rem;
		}
	}

	.sbsourcelistactive {
		background-color: #DDE1FF;
		border-left: 5px solid #2E62BE;
	}

	/deep/ .el-switch__label * {
		font-size: 0.6rem;
	}

	.errorf {
		background-color: #FF0000;
		color: #fff;
	}


	/deep/ .switchStyle .el-switch__label {
		position: absolute;
		display: none;
		color: #ffffff;
	}

	/deep/ .switchStyle .el-switch__label--left {
		z-index: 9;
		left: 25px;
	}

	/deep/ .switchStyle .el-switch__label--right {
		z-index: 9;
		left: 0px;
		top: 0
	}

	/deep/ .switchStyle .el-switch__label.is-active {
		display: block;
	}

	/deep/ .switchStyle.el-switch .el-switch__core,
	/deep/ .el-switch .el-switch__label {
		width: 94px !important;
	}



	.roomstab {
		width: 100%;
		// box-shadow: 0 3px 10px 2px;
		background-color: #fff;
		padding-bottom: 20px;

		.roomstabcontian {

			/deep/ .el-input {
				// margin: 10px 0 0 0;
				input {
					width: 100%;
				}
			}
		}

		// border: 1px solid;
		border-radius: 10px;

		.roomstabtitle {
			display: flex;
			align-items: center;
			border-top-left-radius: 10px;
			border-top-right-radius: 10px;
			color: #fff;
			justify-content: space-between;
			padding: 1rem 0;
			background-color: #06A774;

			.pagination {
				.el-pagination {
					background: transparent;

					/deep/ .btn-prev {
						background-color: #06A774;
						color: #fff;
					}

					/deep/ .btn-next {
						background-color: #06A774;
						color: #fff;
					}

					/deep/.el-pager li.active {
						color: #fff !important;
					}

					/deep/ .el-pager li {
						background-color: transparent !important;
						font-size: 1rem;
						color: #88d8d8;
					}


				}
			}

			div {
				display: flex;
				align-items: center;
			}

			p {
				font-size: 1vw;

				span {
					font-size: 0.4rem;
				}
			}

			span.iconv {
				padding: 0.1rem 0.1rem;
				// border: 1px solid ;
				background-color: rgba(255, 255, 255, .3);
				border-radius: 5px;
				margin: 0 0.4rem;
				font-size: 1.4rem;
				font-weight: 900;
			}
		}

		.title {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			padding: 10px;

			img {
				// margin: 0 0.6rem 0 0;
				height: 5rem;
				width: 100%;
				border-radius: 0.6rem;
			}

			.icnos {
				font-size: 1rem;
				margin: 0 0.6rem;
			}

			.swiperstime {
				font-size: 0.8rem;
				display: block;
				height: 1rem;
				margin-bottom: 0.3rem;
			}

			.swiperszc {
				padding: 1px 10px;
				background-color: #FF8300;
				color: #fff;
				border-radius: 10px;
				height: 1.3rem;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-top: 1.2rem;
				font-size: 0.6rem;
				width: 40%;
			}

			.swipers {
				display: flex;
				font-size: 1rem;
				height: 1.4rem;
				align-items: center;
				justify-content: space-between;

				span {
					margin-right: 1rem;
					color: #333;
					font-weight: 600;

				}
			}

		}

	}

	.roomscontain {
		ul {
			li {
				display: flex;
				align-items: center;
				justify-content: flex-start;

				span {
					display: block;
					text-align: left;
					margin-left: 1.2rem;
				}

				span:first-child {
					width: 4rem;
				}
			}
		}
	}

	.bagrees {
		background-color: #E7F6F1;
	}

	.sbsource {
		padding: 0 10px 20px 10px;
		// border: 1px solid;
		// box-shadow: 0 3px 10px 2px;
		border-radius: 10px;
		width: 100%;
		background: #fff;
		margin-top: 1rem;

		.sbsourcecontinbt {
			width: 100%;
			margin-left: 40%;
		}

		.sbsourcetitle {
			padding: 0 10px;

			ul {
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 10px 0;
				border-bottom: 1px solid #ccc;

				li {
					display: flex;
					align-items: center;

					.sbaddg {
						border: 1px solid;
						padding: 10px;
						border-radius: 10px;
						color: #fff;
						background-color: #07B446;

						span {
							color: #fff;
						}
					}

					.sbsourcetitles {
						p {
							font-size: 1rem;
							color: #333;
							font-weight: 600;
						}

						span {
							letter-spacing: 1px;
						}
					}

					.iconsa {
						margin-right: 10px;
						border: 1px solid;
						font-size: 1.8rem;
						border-radius: 20px;
						padding: 5px;
						background-color: #FFAC07;
						color: #fff;
						display: flex;
						align-items: center;
						justify-content: center;
					}
				}
			}

		}

		/deep/ .el-switch {
			display: flex !important;
			padding: 5px 8px;
			align-items: center;
			justify-content: center;
		}

		.sbsourcelistcz {
			margin-left: 5px;
			margin-bottom: 30px;
			padding: 10px;
			// border-radius: 5px;
			// border-top:1px solid #2E62BE;
			// border-bottom:1px solid #2E62BE;
			// border-right:1px solid #2E62BE;
			border-left: 4px solid #97B1DF;



			.sbsourcelissl {
				p {
					margin: 2px 0;
					font-size: 0.8rem;

				}
			}

			.openscentera {
				// border: 1px solid;
				padding: 0 0.6rem;
				border-radius: 10px;
				color: #fff;
				background-color: #09A706;
			}

			.btnsaf {
				margin-left: 1.2rem;
				position: absolute;
				bottom: -63%;
				right: -3%;
				display: flex;
				align-items: center;

				button {
					margin: 0 2px 0 0;
					border: 1px solid;
					padding: 5px 8px;
					background-color: #2E62BE;
					border-radius: 10px;
					color: #fff;
				}

				// button:last-child {
				// 	background-color: #FFAC07;
				// }
			}

		}

		.sbsourcecontin {
			// border: 1px solid;
			padding: 10px;

			.sbsourcelist {
				display: flex;
				align-items: center;
				justify-content: space-between;

				div {
					p {
						margin: 2px 0;
					}

					p:first-child {
						color: #333;
						font-size: 0.8rem;
						font-weight: 600;
						margin-bottom: 1rem;
					}
				}
			}
		}

		.sbsourcelissl {
			display: flex;
			align-items: center;
			justify-content: space-between;
			position: relative;

			p.cgqip {
				margin-top: 5px;
				display: flex;
				align-items: center;
			}
		}

	}

	/deep/ .el-collapse-item__header {
		height: 6rem;
	}

	.titleconten {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
	}

	/deep/ .el-collapse-item__content {
		padding-bottom: 0 !important;
	}

	/deep/ .el-collapse-item__header.is-active {
		background: #E7F6F1;
	}
</style>


<template>
	<div>
		<titles titlename="设备电源管理" titlecontent="设备电源管理" :mbx="paths"></titles>
		<filters :rooms="filterslist"></filters>
		<el-row :gutter="10">
			<el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6">
				<div class="roomstab" style="margin-top: 1rem;">
					<div class="roomstabtitle">
						<div>
							<span class="el-icon-help iconv"></span>
							<p class="roomstabfont">
								实训室列表
								<!-- <span>查看相关电源设备</span> -->
							</p>
						</div>
						<div class="pagination">
							<el-pagination @current-change="changedatapasetrain" layout="prev, pager, next"
								:page-size="pagesizes" :total="totals">
							</el-pagination>
						</div>
					</div>
					<div class="roomstabcontian">
						<el-input @change="gettaraindy()" placeholder="搜索..." prefix-icon="el-icon-search"
							v-model="search">
						</el-input>
						<el-collapse v-model="activeName" accordion>
							<el-collapse-item :name="index+1" v-for="(item,index) in roomlist"
								@change="collapsecol(item)" :key="index">
								<template slot="title" @click="gettraindy(item,index)">
									<div class="title" style="width: 100%;z-index: 1;" @click="gettraindy(item,index)">
										<div style="width: 40%;margin-right: 0.4rem;">
											<img v-if="item.img" :src="item.img" alt="">
											<img v-else src="../../images/roomimg.jpg" alt="">
										</div>
										<!-- <img src="../../images/roomssxsvg.svg" alt=""> -->
										<div class="titleconten">
											<p class="swipers">
												<span>{{item.tr_name}}</span>
											</p>
											<span class="swiperstime">
												{{item.tr_createTime}}
											</span>
											<div style="width: 100%;display: flex;">
												<span class="swiperszc" v-if="item.tr_isOpen">
													正常开放
												</span>
												<span class="swiperszc" style="background-color: #FF0000;" v-else>
													关闭中
												</span>
												<el-tooltip class="item" effect="dark" content="一键启动或关闭电源"
													placement="right-end">
													<p style="margin-top: 1.2rem;margin-left: 0.4rem;">
														<el-switch @change="changestates(item)" style="display: block"
															v-model="item.tp_status" active-color="#00cc77"
															class="switchStyle" inactive-color="#F00000" active-text="一键启动"
															inactive-text="一键关闭" :active-value="true"
															:inactive-value="false">
														</el-switch>
													</p>
												</el-tooltip>
												
											</div>
										</div>
									</div>
								</template>
								<div class="card card-body" :class="{'bagrees':xollpse==1}">
									<div class="roomscontain">
										<ul>
											<li style="margin: 4px 0;">
												<span style="color: #333;font-weight: 600;font-size: 0.8rem;">地址</span>
												<span style="font-size: 0.8rem;">{{item.tr_address}}</span>
											</li>
											<li style="margin: 4px 0;">
												<span style="color: #333;font-weight: 600;font-size: 0.8rem;">标签</span>
												<span style="font-size: 0.8rem;">{{item.tr_tag}}</span>
											</li>
											<li style="margin: 4px 0;">
												<span style="color: #333;font-weight: 600;font-size: 0.8rem;">责任人</span>
												<span style="font-size: 0.8rem;">{{item.tr_maintenancer}}</span>
											</li>
											<li style="margin: 4px 0;">
												<span style="color: #333;font-weight: 600;font-size: 0.8rem;">电话</span>
												<span style="font-size: 0.8rem;">{{item.tr_mobile}}</span>
											</li>
										</ul>
									</div>
								</div>
							</el-collapse-item>
						</el-collapse>
					</div>
				</div>
			</el-col>
			<el-col :xs="24" :sm="24" :md="24" :lg="18" :xl="18">
				<div class="sbsource">
					<div class="sbsourcetitle">
						<ul>
							<li>
								<span class="el-icon-s-unfold iconsa"></span>
								<div class="sbsourcetitles">
									<p>设备电源</p>
									<span>{{trainsname}}实训室电源设备都在这里</span>
								</div>
							</li>
							<li>
								<button v-if="isaddporders==1" class="sbaddg" @click="goaddsourcemange()">
									<span class="el-icon-plus"></span>
									添加新设备电源
								</button>
							</li>
						</ul>
					</div>
					<div class="sbsourcecontin">
						<el-row :gutter="10">
							<el-empty v-if="powerlists.length == 0" description="暂无电源设备"></el-empty>

							<el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-for="(item,index) in powerlists"
								:key="index">
								<div class="sbsourcelistcz">
									<div class="sbsourcelist">
										<div>
											<p>{{item.sx_tp_name}}</p>
											<p>设备ID：{{item.sx_tp_number}}</p>
											<p>设备状态：<span class="openscentera" v-if="item.sx_tp_state==1">开启</span><span
													class="openscentera" style="background-color: #FF0000;"
													v-if="item.sx_tp_state==-1">关闭</span></p>
										</div>
									</div>
									<div class="sbsourcelissl">
										<div>
											<p>设备位置：{{item.sx_tp_position}}</p>
											<p class="cgqip">
												传感器状态：<cgstatus :nums="7"></cgstatus>
											</p>
										</div>
										<div class="btnsaf">
											<button @click="changepower(item)" v-if="item.isporderedit ==1">
												<span class="el-icon-edit-outline"></span>
												管理
											</button>
											<button v-if="item.isdelecte ==1" @click="delepower(item)" style="background-color: #FFAC07;">
												<span class="el-icon-delete"></span>
												删除
											</button>
											<el-switch @change="changestatesnow(item)" style="display: block"
												v-model="item.sx_tp_state" active-color="#00cc77" class="switchStyle"
												inactive-color="#F00000" active-text="关闭电源" inactive-text="开启电源"
												:active-value="1" :inactive-value="-1">
											</el-switch>
										</div>
									</div>
								</div>
							</el-col>
						</el-row>
					</div>
					<div class="sbsourcecontinbt">
						<el-pagination @current-change="changedatapase" layout="prev, pager, next"
							:page-size="pageSizes" :total="powrtotle">
						</el-pagination>
					</div>
				</div>
			</el-col>
		</el-row>

		<el-dialog :show-close="false" :title="powerstais.sx_tp_name+ '电源管理'" center append-to-body :visible.sync="dialogVisible"
			width="60%" :before-close="handleClose">

			<el-descriptions border :column="2" labelClassName="changeuser">
				<el-descriptions-item :span="3" label="设备电源图片">
					<div>
						<img @click="changeimga()" v-if="powerstais.sx_tp_picUrl==null" src="../../images/powers.png"
							alt="" style="width: 8vw;height: 8vw;">
						<img @click="changeimga()" v-if="powerstais.sx_tp_picUrl != null" :src="powerstais.sx_tp_picUrl"
							alt="" style="width: 8vw;height: 8vw;">
					</div>
					<input @change="preview"  ref="file" type="file" accept=".png,.jpg"  style="display: none;" name="" id="">
				</el-descriptions-item>

				<el-descriptions-item label="设备电源名称">
					<input
						style="padding-left: 6px;box-sizing: border-box;border: 1px solid #ccc;height: 2rem;border-radius: 4px;width: 100%;"
						type="text" v-model="powerstais.sx_tp_name" placeholder="请输入设备电源名称">
				</el-descriptions-item>
				<el-descriptions-item label="设备电源编号">
					{{powerstais.sx_tp_number}}
				</el-descriptions-item>


				<el-descriptions-item label="所属院校">
					<template slot="label">
						<p style="display: flex;align-items: center;">所属院校<span class="musts">*</span></p>
					</template>
					<div>
						<select @change="changeschool()" v-model="defultperobj.si_guid" class="form-control"
							id="exampleFormControlSelect1">
							<option value=""> -- 请选择所属院校 --</option>
							<option v-for="(item,index) in schoollist" :key="index" :label="item.si_name_cn"
								:value="item.si_guid">
								{{item.si_name_cn}}
							</option>
						</select>
					</div>
					<!-- {{userSingleobj.SchoolName}} -->
				</el-descriptions-item>
				<el-descriptions-item label="所属实训室">
					<template slot="label">
						<p style="display: flex;align-items: center;">所属实训室<span class="musts">*</span></p>
					</template>
					<div>
						<select v-model="defultperobj.sx_tr_guid" class="form-control" id="exampleFormControlSelect1"
							placeholder="请选择实训室" @change="chosedDtraintrin">
							<option value="">-- 请选择实训室 --</option>
							<option v-for="(item,index) in trainlist" :key="index" :value="item.sx_tr_guid">
								{{item.tr_name}}
							</option>
						</select>
					</div>
					<!-- {{userSingleobj.SchoolName}} -->
				</el-descriptions-item>
				<el-descriptions-item label="所属实训设备">
					<template slot="label">
						<p style="display: flex;align-items: center;">所属实训设备<span class="musts">*</span></p>
					</template>
					<div>
						<select v-model="powerstais.sx_te_guid" class="form-control" id="exampleFormControlSelect1">
							<option value="">
								-- 请选择所属实训设备 --
							</option>
							<option v-for="(item,index) in trainsblist" :key="index" :lable="item.sx_te_guid"
								:value="item.sx_te_guid">
								{{item.te_deviceName}}
							</option>
						</select>
					</div>
					<!-- {{userSingleobj.SchoolName}} -->
				</el-descriptions-item>


				<el-descriptions-item label="设备电源位置">
					<input 
						style="padding-left: 6px;box-sizing: border-box;border: 1px solid #ccc;height: 2rem;border-radius: 4px;width: 100%;"
						type="text" v-model="powerstais.sx_tp_position">
				</el-descriptions-item>
				<el-descriptions-item label="设备MAC地址">
					<input @input="macchanges()" maxlength="17"
						style="padding-left: 6px;box-sizing: border-box;border: 1px solid #ccc;height: 2rem;border-radius: 4px;width: 100%;"
						type="text" v-model="powerstais.sx_tp_mac" :style="{'border-color':ismacshow?'red':'#ccc'}" >
				</el-descriptions-item>
				<el-descriptions-item label="设备id地址">
					<input @input="ipchanges()" maxlength="17"
						style="padding-left: 6px;box-sizing: border-box;border: 1px solid #ccc;height: 2rem;border-radius: 4px;width: 100%;"
						type="text" v-model="powerstais.sx_tp_ip" :style="{'border-color':isipshow?'red':'#ccc'}">
				</el-descriptions-item>
				
				
				<el-descriptions-item :span="3" label="标签(Tag)">
					<div style="display: flex;flex-wrap: wrap;align-items: center;">
						<el-tag style="margin-right: 0.4rem;margin-bottom: 0.4rem;" :key="tag"
							v-for="tag in dynamicTags" closable :disable-transitions="false" @close="handleClose1(tag)">
							{{tag}}
						</el-tag>
						<div style="width: 10vw;">
							<el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput"
								size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
							</el-input>
							<button v-else size="small" class="button-new-tag" @click="showInput">新增</button>
						</div>
					</div>
				</el-descriptions-item>
				<el-descriptions-item :span="3" label="描述">
					<textarea v-model="powerstais.sx_tp_remarke" name="" id="" rows="10"
						style="width: 100%;padding: 0.8rem;border: 1px solid #ccc;"></textarea>
				</el-descriptions-item>
			</el-descriptions>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="primarychangepower" v-preventReClick>确 定</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import titles from "@/components/title/title.vue"
	import cgstatus from "@/components/cgstatus.vue"
	import filters from "@/components/filters/filterspeower.vue"
	import {
		getTrainRoom,
		GetdyPageTrainPowerList,
		AllTrainPowerEditStatus,
		TrainPowerDelete,
		TrainPowerEditStatus,
		getbfyGetTrainList,
		getTrainEquipmentList,
		TrainPowerUploadImages,
		GetTrainPowerInsertOrEdit
	} from "@/request/api/trainroom/trainroom.js"
	import {
		GetbjGetSchoolList,
	} from "@/request/api/mange/mange.js"
	
	import AppOptions from '@/config/AppOptions.vue';
	
	export default {
		data() {
			return {
				ismacshow: false,
				isipshow: false,
				// 学校id
				siguids: "",
				scoolguids: "",
				// 上传图片修改电源图片
				porwersimg: "",

				// tag组件
				dynamicTags: [],
				inputVisible: false,
				inputValue: '',
				// 学校id获取实训室列表
				scoolguid: "",
				trainlist: [],
				trainsblist: [],
				dialogVisible: false,
				activeName: 1,
				// 设备电源
				pagesizes: 5,
				totals: 10,
				paganum: 1,
				roomlist: [],
				iscollapse: true,
				activesws: "",
				xollpse: 1,
				activesw: "",
				// 搜索
				search: "",
				// 标题组件
				paths: [{
						path: "/allmanage",
						name: "实训管理"
					},
					{
						path: "/allmanage/trainingmange",
						name: "设备电源管理"
					}
				],
				sxtrguid: "",
				// 设备电源
				pageIndexdy: 1,
				pageSizes: 10,
				powerstai: {},
				powerlists: [],
				powrtotle: 0,
				// 实训室名称动态接收
				trainsname: "",
				// 电源设备对象
				powerstais: {},
				schoollist: [],
				defultperobj: {
					sx_te_guid: "",
					sx_tr_guid: "",
					si_guid: ''
				},
				// 筛选组件
				filterslist: {
					name: "设备电源",
					content: "",
					filterlist: [{
						id: 0,
						indexsshol: 0,
						title: "所属院校",
						childers: []
					}]
				},
				// 动态权限指令
				powershowobj: {},
				isaddporders:0
			}
		},
		created() {
			AppOptions.appEmpty = false;
			let powerlist = JSON.parse(window.sessionStorage.getItem("allbtnlist"))
			this.powershowobj.powershows = powerlist
			this.powershowobj.routers = this.$route.path
		},
		beforeMount() {
			let allobj = {
				si_name_cn: "全部",
				shoolid: 0,
				si_guid: ""
			}
			GetbjGetSchoolList().then(res => {
				console.log(res, "院校不分页")
				let schoollist = []
				schoollist = JSON.parse(JSON.stringify(res.data.data))
				this.schoollist = JSON.parse(JSON.stringify(res.data.data))
				if (this.schoollist.length == 1) {
					this.siguids = this.schoollist[0].si_guid
					this.getTrainRooms("", this.schoollist[0].si_guid)
				} else {
					schoollist.unshift(allobj)
					this.getTrainRooms()
				}
				schoollist.forEach(item => {
					item.name = item.si_name_cn
				})
				this.filterslist.filterlist[0].childers = schoollist


			})
		},
		mounted() {},
		updated() {

		},
		methods: {
			macchanges() {
				var reg_name = /[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}/
				var reg_name1 = /[A-F\d]{2}-[A-F\d]{2}-[A-F\d]{2}-[A-F\d]{2}-[A-F\d]{2}-[A-F\d]{2}/
				if (reg_name.test(this.powerstais.sx_tp_mac) || reg_name1.test(this.powerstais.sx_tp_mac)) {
					this.ismacshow = false
					// console.log("进入正确",reg_name1.test(this.powerstais.sx_tp_mac))
				} else {
					this.ismacshow = true
					// console.log("进入正确",reg_name1.test(this.powerstais.sx_tp_mac))
				}
			},
			ipchanges() {
				var reg_name = /^((?:(?:25[0-5]|2[0-4]\d|[01]?\d?\d)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d?\d))$/
				if (!reg_name.test(this.powerstais.sx_tp_ip)) {
					this.isipshow = true
				} else {
					this.isipshow = false
				}
			},
			
			// 修改电源设备
			primarychangepower() {
				let insertobj = {
					sx_tp_guid: this.powerstais.sx_tp_guid ?? "",
					sx_tp_name: this.powerstais.sx_tp_name,
					sx_tp_number: this.powerstais.sx_tp_number,
					sx_tp_tags: this.dynamicTags.join("#"),
					sx_tp_remarke: this.powerstais.sx_tp_remarke,
					sx_tp_state: 1,
					sx_te_guid: this.powerstais.sx_te_guid,
					filename: this.powerstais.sx_tp_picUrl ?? "",
					sx_tp_position: this.powerstais.sx_tp_position,
					sx_tp_mac:this.powerstais.sx_tp_mac,
					sx_tp_ip:this.powerstais.sx_tp_ip
					
				}
				let from_data = new FormData()
				from_data.append("sx_tp_guid", insertobj.sx_tp_guid ?? '')
				from_data.append("sx_tp_name", insertobj.sx_tp_name ?? '')
				from_data.append("sx_tp_number", insertobj.sx_tp_number ?? '')
				from_data.append("sx_tp_tags", insertobj.sx_tp_tags ?? '')
				from_data.append("sx_tp_remarke", insertobj.sx_tp_remarke ?? '')
				from_data.append("sx_tp_state", insertobj.sx_tp_state ?? '')
				from_data.append("sx_te_guid", insertobj.sx_te_guid ?? '')
				from_data.append("filename", '')
				from_data.append("sx_tp_position", insertobj.sx_tp_position ?? '')
				from_data.append("sx_tp_mac", insertobj.sx_tp_mac ?? '')
				from_data.append("sx_tp_ip", insertobj.sx_tp_ip ?? '')
				
				if (this.defultperobj.si_guid == '') {
					this.$message("学校不能为空")
				} else if (this.powerstais.sx_tr_guid == '') {
					this.$message("实训室不能为空")
				} else {
					console.log(insertobj)

					GetTrainPowerInsertOrEdit(from_data).then(res => {
						if (res.data.code == 1) {
							this.$message({
								message: '恭喜你，' + res.data.msg,
								type: 'success'
							});
							this.dialogVisible = false
						} else {
							this.$message(res.data.msg);
						}
					})
				}
			},
			// 标签
			handleClose1(tag) {
				this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
			},
			handleInputConfirm() {
				let inputValue = this.inputValue;
				if (inputValue) {
					this.dynamicTags.push(inputValue);
				}
				this.inputVisible = false;
				this.inputValue = '';
			},
			showInput() {
				this.inputVisible = true;
				this.$nextTick(() => {
					this.$refs.saveTagInput.$refs.input.focus();
				});
			},

			// 上传头像
			changeimga() {
				this.$refs.file.click()
			},
			// 上传图片
			preview: function(e) {
				console.log("发送图片")
				let _this = this;
				let file = e.target.files[0]
				if (!file) {
					return
				}
				var imgs = ""
				var reader = new FileReader()
				reader.readAsDataURL(e.target.files[0])
				reader.onload = function() {
					imgs = this.result
					_this.powerstais.sx_tp_picUrl = imgs
				}
				// var form_data = new FormData().append(file);
				var form_data = new FormData();
				form_data.append('filename', file)
				form_data.append('sx_tp_guid', _this.powerstais.sx_tp_guid)
				console.log(form_data)
				TrainPowerUploadImages(form_data).then(res => {
					console.log(res)
					if (res.data.code == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});
						this.porwersimg = res.data.data
						// this.handleClick(this.userSingleobj)
						// this.changepower()
					} else {
						this.$message(res.data.msg, "格式默认人为jpg/png");
					}
				})

			},


			// 修改实训室获取设备
			chosedDtraintrin() {
				this.chosedDtrainsb(this.defultperobj.sx_tr_guid)
				this.powerstais.sx_te_guid = ""
			},
			// 修改学校获取实训室
			changeschool() {
				this.getmanges(this.defultperobj.si_guid)
				this.powerstais.sx_te_guid = ""
				this.defultperobj.sx_tr_guid = ""
			},
			// 获取实训室
			getmanges(ifs) {
				getbfyGetTrainList(ifs).then(res => {
					console.log(res, "实训室不分页")
					this.trainlist = res.data.data
				})
				// this.chosedDtrainsb()

			},
			// 获取实训设备
			chosedDtrainsb(itemid = null) {
				let dtrainobj = {
					sx_tr_guid: itemid ?? "",
					te_deviceName: "",
					si_guid:this.defultperobj.si_guid
				}
				getTrainEquipmentList(dtrainobj).then(res => {
					console.log(res, "设备不分页")
					this.trainsblist = res.data.data
					// console.log(this.defultperobj.sx_te_guid,res.data.data)
				})
			},
			handleClose(done) {
				// this.$confirm('确认关闭？')
				// 	.then(_ => {
				// 		done();
				// 	})
				// 	.catch(_ => {});
			},
			// 分页
			changedatapasetrain(val) {
				this.paganum = val
				this.getTrainRooms("", this.siguids)
			},
			// 管理电源
			changepower(itm) {
				console.log(itm, "管理电源")
				this.dialogVisible = true
				this.powerstais = itm
				if (itm.sx_tp_tags) {
					this.dynamicTags = this.powerstais.sx_tp_tags.split("#")
					console.log(this.dynamicTags, "管理电源")
				}
				this.getmanges(this.defultperobj.si_guid)
				this.chosedDtrainsb(this.defultperobj.sx_tr_guid)
			},


			// 删除电源
			delepower(itm) {
				this.$confirm('确定删除这条记录吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					TrainPowerDelete(itm.sx_tp_guid).then(res => {
						// console.log(res)
						if (res.data.code == 1) {
							this.$message({
								message: '恭喜你，' + res.data.msg,
								type: 'success'
							});
							this.getsbdytrain()
						} else {
							this.$message(res.data.msg);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},

			// 去添加
			goaddsourcemange() {
				this.$router.push({
					path: "/device/addsourcemange?siguid=" + this.scoolguids + "&sx_tr_guid=" + this.sxtrguid
				})
			},
			// 根据实训获取电源
			collapsecol(itm) {
				this.sxtrguid = itm.sx_tr_guid
				this.getsbdytrain()
			},
			// 切换实训室设备
			gettraindy(itm, idx) {
				console.log(itm, "实训室点击")
				this.sxtrguid = itm.sx_tr_guid
				this.trainsname = itm.tr_name
				this.defultperobj = itm
				this.getsbdytrain()


			},
			// 搜索实训室
			gettaraindy() {
				this.getTrainRooms(this.search)
			},
			// 一键开关设备
			changestates(itm) {
				// console.log(itm, '开关')
				let traineditsta = {
					sx_tr_guid: itm.sx_tr_guid,
					sx_tp_state: itm.tp_status ? 1 : -1,
					ui_guid: localStorage.getItem("uiguid")
				}
				AllTrainPowerEditStatus(traineditsta).then(res => {
					// console.log(res, '开关')
					if (res.data.code == 1) {
						this.$message({
							message: '恭喜你，' + res.data.msg,
							type: 'success'
						});
						this.getsbdytrain()
					} else {
						this.$message(res.data.msg);
					}
				})
			},

			changestatesnow(item) {
				console.log(item)
				let EditStatusobj = {
					sx_tp_guid: item.sx_tp_guid,
					sx_tp_state: item.sx_tp_state,
					ui_guid: localStorage.getItem("uiguid"),
					sx_tr_name: this.trainsname
				}
				TrainPowerEditStatus(EditStatusobj).then(res => {
					if (res.data.code == 1) {
						this.$message({
							message: '恭喜你，' + res.data.msg,
							type: 'success'
						});
						this.getsbdytrain()

					} else {
						this.$message(res.data.msg);
					}
				})
			},

			getsbdytrain(scoolguid = null) {
				let TrainPowerobj = {
					pageIndex: this.pageIndexdy,
					pageSize: this.pageSizes,
					sx_tp_name: "",
					sx_tp_number: "",
					si_guid: scoolguid ?? "",
					sx_tr_guid: this.sxtrguid
				}
				// console.log(scoolguid,"拿学校的id")

				GetdyPageTrainPowerList(TrainPowerobj).then(res => {
					console.log(res, '设备电源')
					let powerlists = []

					powerlists = res.data.data.list
					this.powerlists = powerlists
					this.powerlists.forEach(item=>{
						item.isporderedit = 0
						item.isdelecte = 0
					})
					this.powershowobj.powershows.forEach(item => {
						if (item.path == this.$route.path && item.title == "删除电源") {
							this.powerlists.forEach(ite => {
								ite.isdelecte = 1
							})
							
							console.log("进入删除")
							
						} else if (item.path == this.$route.path && item.title == '修改') {
							this.powerlists.forEach(ite => {
								ite.isporderedit = 1
							})
						} else if (item.path == this.$route.path && item.title == '添加设备电源') {
							this.isaddporders = 1
						}
					})
					
					
					
					if (powerlists.length == 0) {
						this.powerlists = []
					}
					this.powrtotle = res.data.data.totalCount
				})
			},
			changedatapase(val) {
				console.log(val)
				this.paganum = val
				this.getTrainRooms()
			},
			// 实训室获取
			getTrainRooms(trname = null, scoolguid = null) {
				var TrainRoom = {
					nums: this.paganum,
					size: this.pagesizes,
					tr_name: trname == null ? "" : trname,
					si_guid: scoolguid ?? this.scoolguid
				}
				console.log("切换学校拿学校id", scoolguid)

				getTrainRoom(TrainRoom).then(res => {
					console.log(res.data.data, "实训室")
					let roomlist = []
					roomlist = res.data.data.list
					this.roomlist = roomlist
					this.scoolguids = scoolguid ?? ""

					if (this.roomlist[0] && roomlist.length > 0) {
						this.sxtrguid = this.roomlist[0].sx_tr_guid
						this.powerstai = this.roomlist[0]
						this.trainsname = this.roomlist[0].tr_name
						this.activeName = 1
						this.defultperobj = this.roomlist[0]
						this.getsbdytrain(scoolguid)
						console.log("实训室不为零")
					} else {
						this.powerlists = []
						this.trainsname = ""
						this.sxtrguid = ""
						console.log("实训室零")
					}

					this.roomlist.forEach(item => {
						item.tr_tag = item.tr_tag.split("#")
						if (item.PicList.length > 0) {
							item.img = item.PicList[0].sx_tp_imgPath
						} else {
							item.img = ""
						}
						item.tr_tag = item.tr_tag.join("  |  ")
					})
					console.log(this.roomlist, "实训室")
					this.totals = res.data.data.totalCount



				})
			},

			clickdzy() {
				if (this.xollpse == 2) {
					this.xollpse = 1
				} else {
					this.xollpse = 2
				}
			}

		},
		components: {
			titles,
			cgstatus,
			filters
		}
	}
</script>

<style>
</style>
